import { auditReports } from '@mi-front/api-clients';
import { QueryView } from '@mi-front/ui';
import moment from 'moment';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { Page } from '../../../../../../components/page/Page';
import { AodBreadcrumbs } from '../../components/AodBreadcrumbs';
import { aodRoutes } from '../../routing/routes';
import { AodRunInfo } from './components/AodRunInfo';
import { AodRunRestartButton } from './components/AodRunRestartButton';

export function AodRunViewPage() {
  const { id } = useParams<{ id: string }>();
  const { formatMessage } = useIntl();

  const runQuery = auditReports.useGetOneBaseAodRunsControllerAodRun(
    id,
    {
      join: ['rule'],
    },
    {
      query: {
        refetchInterval: (query) => {
          return query.state.data?.isPending ? 3000 : false;
        },
      },
    },
  );

  return (
    <QueryView query={runQuery}>
      {(run) => {
        // FIXME must be localized
        const title = `Ejecución ${run.rule.name} - ${moment(run.scheduledDatetime).format(
          'DD/MM/YYYY',
        )}`;

        return (
          <Page htmlTitle={title}>
            <Page.Header
              title={title}
              backBtn={aodRoutes.runsPast.gen()}
              breadcrumbs={
                <AodBreadcrumbs
                  items={[
                    {
                      href: aodRoutes.runsPast.gen(),
                      content: formatMessage({
                        id: 'audit.aod.runs.title',
                        defaultMessage: 'Ejecuciones',
                      }),
                    },
                  ]}
                />
              }
              actions={<AodRunRestartButton run={run} />}
            />
            <Page.Content>
              <AodRunInfo run={run} />
            </Page.Content>
          </Page>
        );
      }}
    </QueryView>
  );
}
